var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-field',{attrs:{"label":_vm.label,"type":(_vm.hasError() ? 'is-danger': ''),"message":_vm.errorMessage()}},[_c('b-rate',{attrs:{"value":_vm.value,"max":_vm.max,"name":_vm.name},on:{"change":_vm.inputListener}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }